import { render } from "./TransactionLinkedView.vue?vue&type=template&id=8549b98a"
import script from "./TransactionLinkedView.vue?vue&type=script&lang=js"
export * from "./TransactionLinkedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__